import { useContext } from 'react';
import { AuthContext } from './AuthContext';

export const useAuth = () => {
  const { state } = useContext(AuthContext);

  return {
    ...state
  };
};
